import GridTile from "../grid/GridTile";
import WorldGrid from "../grid/WorldGrid";
import Vector from "../math/Vector";

export default class LineBasedSkill {
    /**
     * @abstract
     * @param {WorldGrid} worldGrid
     */
    constructor(worldGrid) {

        /**
         * @constant
         * @type {WorldGrid}
         */
        this.worldGrid = worldGrid;

        /**
         * @constant
         * @type {Vector}
         */
        this.startPoint = new Vector(0, 0);
        /**
         * @constant
         * @type {Vector}
         */
        this.endPoint = new Vector(0, 0);

        /**
         * @constant
         * @type {Vector}
         */
        this.workingPosition = new Vector(0, 0);

    }

    /**
     * @param {GridTile} prevTile
     * @param {Vector} projectedPosition
     * @returns {GridTile}
     */
    getProjectedTile(prevTile, projectedPosition) {

        if (prevTile && prevTile.contains(projectedPosition)) {
            return prevTile;
        }

        return this.worldGrid.findGridTile(projectedPosition);
    }
}